import { homeUi } from "../../../utilities/home-ui";

export function initHome(container) {
  console.log("initHome", container);

  // Initialize the home UI and get the cleanup function
  const cleanupHomeUi = homeUi(container);

  // Return the cleanup function
  return () => {
    if (cleanupHomeUi) {
      cleanupHomeUi();
    }
    console.log("initHome cleanup complete");
  };
}